export const MyAccountResourcesDE: MyAccountResourcesInterface = {
  title: "Mein Konto",
  nextButton: "Weiter",
  backButton: "Zurück",
  signatureTitle: "Unterschrift",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  phoneNumber: {
    label: "Telefonnummer",
    placeholder: "Bitte Telefonnummer eingeben",
  },
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
  },
  profilePicture: {
    label: "Profilbild",
    name: "profilePicture",
    error: "Bitte wählen Sie Ihr Profilbild aus",
    validation: "Falsches Profilbild",
    description: () => (
      <>
        <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
        <span className="text-muted font-13">Nur Bilder, max 6MB</span>
      </>
    ),
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  errorPasswordMatch: "Passwörter stimmen nicht überein.",
  password: {
    label: "Passwort",
    placeholder: "Bitte geben Sie das Passwort ein",
  },
  passwordRepeat: {
    label: "Passwort wiederholen",
    placeholder: "Bitte wiederholen Sie das Passwort",
  },
};

interface IErrors {
  registerPic: string;
}

export interface MyAccountResourcesInterface {
  title: string;
  nextButton: string;
  backButton: string;
  signatureTitle: string;
  errorMissingInput: string;
  phoneNumber: {
    label: string;
    placeholder: string;
  };
  profilePicture: {
    label: string;
    name: string;
    error: string;
    validation: string;
    description: () => JSX.Element;
  };
  errorPasswordMatch: string;
  password: {
    label: string;
    placeholder: string;
  };
  passwordRepeat: {
    label: string;
    placeholder: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  errors: IErrors;
}
